/**
 * contains the data structure for one multiple choice data. It can be used for a variety of form fields such as radio/checkboxes/rating/select and others
 * some of this props are NOT used at the moment, but put them here as they will be needed when introducing quiz fields
 */
import { PropTypes } from 'console-kit';
import _ from 'lodash';

import { FIELD_TYPES } from '../../../../../common/formFields/fieldTypes';
import { QuizCategoryResultDataPropType, QuizCategoryResultData } from './QuizCategoryResultData';

//Prop type and defaults for a multi choice field like radio/checkbox/poll/multi opt in/...
const MultipleChoiceDataPropType = {
  id:              PropTypes.string, //this is the data, that a user can change for an option using the UI
  idChangedByUser: PropTypes.bool, //keep track, if a user modified the 'id' field
  remoteId:        PropTypes.string, //this will be a remoteId we generate at creation time and never change. Will be used for options that should never change, so that we can properly track poll options or challenge question options on the back end and on the display side
  label:           PropTypes.string,
  description:     PropTypes.string,
  selected:        PropTypes.bool,
  isCustomChoice:  PropTypes.bool,
  imageAssetRef:   PropTypes.string,
  embedCode:       PropTypes.string,
  daysShown:       PropTypes.string,
};

const MultipleChoiceData = {
  id:              '',
  idChangedByUser: false,
  remoteId:        '',
  label:           '',
  description:     '',
  selected:        false,
  isCustomChoice:  false,
  imageAssetRef:   '',
  embedCode:       '',
};

//Prop type for a single answer/multiple answer quiz
const MultipleChoiceScoreQuizDataPropType = _.merge({}, MultipleChoiceDataPropType, {
  score:         PropTypes.number,
  answerMessage: PropTypes.string,
});

const MultipleChoiceScoreQuizData = _.merge({}, MultipleChoiceData, {
  score:         0, //for quiz will hold the score of the option
  answerMessage: '',
});

//Prop type for a category quiz
const MultipleChoiceCategoryQuizDataPropType = _.merge({}, MultipleChoiceDataPropType, {
  categoryResult: PropTypes.shape(QuizCategoryResultDataPropType),
});

const MultipleChoiceCategoryQuizData = _.merge({}, MultipleChoiceData, {
  categoryResult:       _.cloneDeep(QuizCategoryResultData),
  categoryResultIdList: [],
});

/**
 * Based on field type, will return the default multichoice data
 * @param {string} fieldType
 * @returns {object}
 */
const getDefaultMultichoiceData = (fieldType) => {
  //based on module type, we need to supply different empty object for the option
  switch (fieldType) {
    case FIELD_TYPES.QUIZ_SINGLE_ANSWER:
    case FIELD_TYPES.QUIZ_MULTIPLE_ANSWER:
      return MultipleChoiceScoreQuizData;

    case FIELD_TYPES.QUIZ_CATEGORY:
    case FIELD_TYPES.MX_QUIZ_CATEGORY_SINGLE:
    case FIELD_TYPES.MX_QUIZ_CATEGORY_MULTIPLE:
      return MultipleChoiceCategoryQuizData;
    default:
      return MultipleChoiceData;
  }
};

export {
  MultipleChoiceDataPropType,
  MultipleChoiceScoreQuizDataPropType,
  MultipleChoiceCategoryQuizDataPropType,
  MultipleChoiceData,
  MultipleChoiceScoreQuizData,
  MultipleChoiceCategoryQuizData,
  getDefaultMultichoiceData,
};
